'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isExpanded"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Content } from "./Content.mjs";
export var AccordionContent = /*#__PURE__*/React.forwardRef(function AccordionContent(_ref, ref) {
  var isExpanded = _ref.isExpanded,
    props = _objectWithoutProperties(_ref, _excluded);
  return isExpanded ? /*#__PURE__*/React.createElement(Content, Object.assign({
    ref: ref
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.AccordionContent
  })) : null;
});